import BaseService from './base.service';

class ManagersService extends BaseService {
  get basePath() {
    return 'account-managers';
  }
}

export default new ManagersService();
